<template>
  <router-link :to="routerPath" tag="a">{{ value }}</router-link>
</template>

<script>
import Console from '@/shared/console';
import routingOptions from '../config/routingOptions.js';

export default {
  name: 'cell-dt-router-type',

  props: {
    path: {
      type: String,
      default: null,
    },
    configColumn: {
      type: Object,
    },
    dataRow: {
      type: Object,
    },
    value: {
      type: null,
      default: null,
    },
  },

  computed: {
    routerPath() {
      if (!this.configColumn || !this.dataRow || !routingOptions[this.configColumn?.EmitEventName]) {
        Console.error('Do not forget to define the function associated with the EmitEventName in routingOptions.js');
        return '';
      }
      return routingOptions[this.configColumn?.EmitEventName](this.dataRow);
    },
  },
};
</script>

<style scoped>
a {
  color: #000;
  white-space: pre;
}
</style>
